import { RoleCode } from "./plugins/auth/roles";

export default [
  {
    id: "user",
    name: "Администрирование",
    route: "user",
    auth: [RoleCode.ADMINISTRATION_READ_INTERNAL],
    icon: "gear",
  },
  {
    id: "sly-shopping",
    name: "Гарантированная скидка на покупку",
    icon: "cart-shopping",
    route: "sly-shopping",
    auth: [RoleCode.SLY_SHOPPING_READ],
  },
  {
    id: "product",
    name: "Поиск товара",
    route: "product",
    icon: "boxes-packing",
    auth: [RoleCode.PRODUCTS_READ],
  },
  {
    id: "clock-rotate-left",
    name: "История покупок клиента",
    methodName: "openPurchaseHistory",
    icon: "clock-rotate-left",
    auth: [RoleCode.PURCHASE_HISTORY_READ],
  },
  {
    id: "money-bill-trend-up",
    name: "Проверка баланса бонусных рублей",
    methodName: "rubleBalanceShow",
    icon: "money-bill-trend-up",
    auth: [RoleCode.RUBLE_BALANCE_READ],
  },
  {
    id: "fa-id-card",
    name: "Отправка карты гостя",
    methodName: "openSendCardForm",
    icon: "fa-id-card",
    auth: [RoleCode.SEND_GUEST_CARD_READ],
  },
  {
    id: "tags",
    name: "Привязка/отвязка купонов",
    auth: [RoleCode.COUPON_MAPPING_WRITE_INTERNAL],
    methodName: "openCouponMappingDialog",
    icon: "tags",
  },
  {
    id: "fa-money-bill-transfer",
    name: "Начисление и списание бонусов",
    auth: [RoleCode.MANUAL_BONUS_CALC_WRITE_INTERNAL],
    methodName: "openManualBonusCalculationForm",
    icon: "fa-money-bill-transfer",
  },
  {
    id: "user-minus",
    name: "Разбивка связки 'Телефон - номер карты'",
    methodName: "openPhoneUnmapDialog",
    icon: "user-minus",
    auth: [RoleCode.PHONE_UNMAP_READ],
  },
  {
    id: "envelope",
    name: "Рассылка писем",
    auth: ["mail-sender-rule"], // Временно отключён
    methodName: "openMailSenderDialog",
    icon: "envelope",
  },
  {
    id: "communications",
    name: "История рассылки",
    auth: [RoleCode.COMMUNICATION_HISTORY_READ],
    methodName: "openCommunicationDialog",
    icon: "envelopes-bulk",
  },
  {
    id: "metropolis",
    name: "Метрополия",
    methodName: "openMetropoliaDialog",
    icon: "place-of-worship",
    auth: [RoleCode.METROPOLIS_READ],
  },
  {
    id: "emailConfirmation",
    name: "Подтверждение Email",
    methodName: "openEmailConfirmationDialog",
    icon: "envelope-circle-check",
    auth: [RoleCode.EMAIL_CONFIRMATION_READ],
  },
  {
    id: "fileStorage",
    name: "Файловое хранилище",
    icon: "folder-tree",
    route: "file-storage",
    methodName: "",
    auth: [RoleCode.FILE_STORAGE_READ],
  },
  {
    id: "calls",
    name: "Обзвон",
    icon: "headset",
    route: "calls",
    methodName: "",
    auth: [RoleCode.CALLS_WRITE_INTERNAL],
  },
  {
    id: "couponCheck",
    name: "Проверка и отправка купонов",
    methodName: "openCouponCheckDialog",
    icon: "list-check",
    auth: [RoleCode.COUPON_CHECK_READ],
  },
  {
    id: "id-card-clip",
    name: "Замена карты клиента в Viber бот и Телеграмм бот",
    methodName: "openreplacingCardInMessengersDialog",
    icon: "id-card-clip",
    auth: [RoleCode.REPL_CARD_IN_MSG_WRITE],
  },
  {
    id: "hurricane",
    name: "CFM",
    route: "clients",
    icon: "hurricane",
    auth: [RoleCode.CLIENTS_READ],
  },
  {
    id: "user-group",
    name: "Список приглашенных друзей",
    methodName: "openInvitations",
    icon: "user-group",
    auth: [RoleCode.INVITATIONS_READ],
  },
  {
    id: "id-badge",
    name: "Кэшбэк за клик",
    methodName: "cashbackShow",
    icon: "id-badge",
    auth: [RoleCode.CASHBACK_READ],
  },
  {
    id: "fraud",
    name: "FRAUD",
    methodName: "openFraudDialog",
    icon: "fa-user-lock",
    index: 21,
    auth: [RoleCode.FRAUD_READ_INTERNAL],
  },
  {
    icon: "fa-gift",
    id: "promocodes",
    methodName: "openPromocodesDialog",
    name: "Промокоды",
    auth: [RoleCode.PROMOCODES_READ],
  },
  {
    icon: "people-roof",
    id: "relatives",
    methodName: "openRelativesDialog",
    name: "Родственники",
    auth: [RoleCode.RELATIVES_READ],
  },
  {
    icon: "fa-m",
    id: "m-shop",
    route: "m-shop",
    name: "M|SHOP bot",
    auth: [RoleCode.M_SHOP_READ_INTERNAL],
  },
  {
    id: "base",
    name: "Базы",
    route: "base",
    icon: "table",
    auth: [RoleCode.BASE_READ],
  },
  {
    id: "metro-bonus",
    name: "METRO БОНУС",
    methodName: "openMetroBonusDialog",
    icon: "star",
    auth: [RoleCode.METRO_BONUS_READ],
  },
  {
    id: "delivery-admin",
    name: "Админка заказов",
    methodName: "openDeliveryAdminDialog",
    icon: "fa-truck-fast",
    auth: [RoleCode.DELIVERY_ADMIN_READ],
  },
  {
    id: "crm-mechanics",
    name: "CRM механики",
    route: "crm-mechanics-add",
    icon: "circle-dollar-to-slot",
    auth: [RoleCode.CRM_MECHANICS_WRITE_INTERNAL],
  },
  {
    id: "alcoguru",
    name: "АлкоГуру",
    methodName: "openAlcoguruDialog",
    icon: "fa-wine-glass",
    auth: [RoleCode.ALCOGURU_READ],
  },
];
